import { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import crudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import ToastMessages from "../../../../ToastMessages";

/** Visible only when this makes sense: approved, not posted, and mine to decide. */
export const canWithdraw = (schedule, currentUsername) =>
  Boolean(
    schedule
    && schedule.approval_status === "approved"
    && !schedule.posted_at
    && schedule.post_status !== "published"
    && currentUsername
    && schedule.publish_as?.username === currentUsername
  );

/**
 * Takes an approval back. The schedule goes back to "waiting for approval";
 * the author is told and nothing publishes until it is approved again.
 */
const WithdrawApprovalButton = ({ schedule, onDone, size = undefined, style = {} }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const withdraw = async () => {
    setBusy(true);
    const r = await crudApi.edit(SocialEndpoints.posts.schedule.approvals.withdraw + schedule.id, {}, true);
    setBusy(false);
    if (r.ok) {
      ToastMessages.SuccessfulSave(t("Backend.Approvals.Withdrawn", "Approval removed. The post waits for your decision again."));
      onDone?.(r.data);
    } else {
      ToastMessages.Error();
    }
  };

  return (
    <Button
      variant="outline-secondary"
      size={size}
      onClick={(e) => { e.stopPropagation(); withdraw(); }}
      disabled={busy}
      style={{ borderRadius: 8, display: "inline-flex", alignItems: "center", gap: 6, ...style }}
    >
      <FontAwesomeIcon icon={faRotateLeft} /> {t("Backend.Approvals.Withdraw", "Remove approval")}
    </Button>
  );
};

export default WithdrawApprovalButton;
